module.exports = __webpack_public_path__ + "img/1 (96).e3350729.png";